import { useNavigate } from "react-router-dom";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { Confirm } from "../../assets/Icons";
import Button from "../../components/ui/Button";
import { declarationDefault, transactionDetails, transactionId } from "../../store";

export const ConfirmationPage = () => {
  const transactionData = useRecoilValue(transactionDetails);
  const resetTransaction = useResetRecoilState(transactionDetails);
  const resetDeclaration = useResetRecoilState(declarationDefault);
  const transactionNumber = useRecoilValue(transactionId);
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col mt-56">
        <Confirm />
      </div>
      <span className="text-[30px] font-bold mt-10">Thank you for transacting with us!</span>
      <p className="mt-5 text-[18px] font-semibold">
        Please make sure the payment of {transactionData?.total_pay} is transferred within the next
        30 hours.
      </p>
      <p className="mt-2 text-[18px] font-semibold">
        <span className="font-bold">Transaction ID</span> : {transactionNumber}
      </p>
      <p className="mt-2 text-[18px] font-semibold">
        You can see the status of your transaction from your{" "}
        <span
          onClick={() => navigate("/home")}
          className="font-bold cursor-pointer text-primary-100"
        >
          dashboard
        </span>
        .
      </p>
      <p className="mt-2 text-[18px] font-semibold">
        Please upload a payment confirmation screenshot displaying your name by clicking{" "}
        <span
          onClick={() => navigate("/history")}
          className="font-bold cursor-pointer text-primary-100"
        >
          here
        </span>
        .
      </p>
      <div className="mt-2 text-[18px] font-semibold">
        In Case of any query, feel free to reach out to the HOP Support at{" "}
        <a href="mailto:care@moneyhop.co" className="font-bold cursor-pointer text-primary-100">
          care@moneyhop.co
        </a>
      </div>
      <Button
        bgColor="bg-primary-1050"
        fontStyle={{
          fontFamily: "",
          fontSize: "text-md",
          fontWeight: "font-medium",
          fontColor: "text-white",
        }}
        borderStyle={{
          borderRadius: "rounded",
        }}
        className="py-[15px] mt-20 px-[60px] confirmation-go-home"
        onClickHandler={() => {
          navigate("/home");
          resetTransaction();
          resetDeclaration();
        }}
      >
        {"Go Home"}
      </Button>
    </div>
  );
};
